import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldStatsVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type ApiWorldStats = { creators: { totalItems: number, items: Array<{ name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }> }, stats: { mintCount: number, availableNftCount: number, dropCount: number, editionCount: number, liveAuctionCount: number, liveDropCount: number, liveEditionCount: number, soldNftCount: number, totalSales: number, endedAuctionCount: number, soldListingCount: number, soldListingTotalSales: number, momentCount: number } | null, collectors: { totalItems: number, items: Array<{ user: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> } };



export const ApiWorldStatsDocument = /*#__PURE__*/ `
    query WorldStats($id: Int!) {
  creators: exhibitionCreators(exhibitionId: $id, page: 0, perPage: 3) {
    totalItems
    items {
      ...UserLightFragment
    }
  }
  stats: exhibitionStats(exhibitionId: $id) {
    mintCount
    availableNftCount
    dropCount
    editionCount
    liveAuctionCount
    liveDropCount
    liveEditionCount
    soldNftCount
    totalSales
    endedAuctionCount
    soldListingCount
    soldListingTotalSales
    momentCount
  }
  collectors: exhibitionCollectorStats(exhibitionId: $id, perPage: 3, page: 0) {
    totalItems
    items {
      user {
        ...UserLightFragment
      }
    }
  }
}
    ${UserLightFragment}`;

export const useWorldStats = <
      TData = ApiWorldStats,
      TError = ClientError
    >(
      variables: ApiWorldStatsVariables,
      options?: Omit<UseQueryOptions<ApiWorldStats, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldStats, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldStats, TError, TData>(
      {
    queryKey: ['WorldStats', variables],
    queryFn: apiFetcher<ApiWorldStats, ApiWorldStatsVariables>(ApiWorldStatsDocument, variables),
    ...options
  }
    )};

useWorldStats.getKey = (variables: ApiWorldStatsVariables) => ['WorldStats', variables];

export const useInfiniteWorldStats = <
      TData = InfiniteData<ApiWorldStats>,
      TError = ClientError
    >(
      variables: ApiWorldStatsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldStats, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldStats, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldStats, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldStats.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldStats, ApiWorldStatsVariables>(ApiWorldStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldStats.getKey = (variables: ApiWorldStatsVariables) => ['WorldStats.infinite', variables];


useWorldStats.fetcher = (variables: ApiWorldStatsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldStats, ApiWorldStatsVariables>(ApiWorldStatsDocument, variables, options);
